import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import Shipment from './shipment';
import Address from './address';
import ZoneService from '../../services/zone-service';
import ShipmentsUtils from '../../services/shipments-utils';
import translations from '../../../translations/app-translations.json';

class OrderPanelView extends Component {
    _panelHeaderMarkup() {
        const { order } = this.props;
        return (
            <div className="order-panel-header no-margin">
                <div className="label-block-row order-padding">
                    <label className="label label-default">
                        <FormattedMessage id="orderNumber" defaultMessage="Ref" />
                        {`: ${order.number}`}
                    </label>
                    <label className="label label-normal">
                        {order.shipments && order.shipments.length}
                        &nbsp;
                        <FormattedMessage id="packages" defaultMessage="Package(s)" />
                    </label>
                    <label className="label label-normal">
                        <FormattedMessage id="orderTotal" defaultMessage="Order Total" />
                        {`: ${order.display_total}`}
                    </label>
                    {!ZoneService.isDonationZone() && (
                        <div className="order-address-block">
                            <label>
                                <FormattedMessage id="shippingAddress" defaultMessage="Shipping Address" />
                                : &nbsp;
                            </label>
                            <Address address={{ ...order.ship_address, ...(order.ship_address && order.ship_address.attributes) ? order.ship_address.attributes : [] }} />
                        </div>
                    )}
                </div>
            </div>
        );
    }

    render() {
        const { order: thisOrder, stores } = this.props;
        const shipments = stores && stores.length > 0 && thisOrder.shipments && thisOrder.shipments.length > 0 && thisOrder.shipments.sort(ShipmentsUtils.compareShipments);

        const storeIdsCount = ShipmentsUtils.countAmountOfStores(thisOrder.shipments);
        let lastStore;
        let cont = 0;

        const shipmentsMarkup = shipments && shipments.length > 0 && shipments.map((shipment, idx) => {
            const store = stores && stores.find((store) => store.id === shipment.attributes.store_ids[0]);
            if (store !== lastStore) {
                lastStore = store;
                cont = 0;
            } else {
                cont += 1;
            }

            return (
                <Shipment
                    key={idx}
                    store={stores && stores.find((store) => store.id === shipment.attributes.store_ids[0])}
                    shipment={shipment}
                    address={thisOrder.ship_address}
                    order={this.props.order}
                    hideStoreName={ShipmentsUtils.prevIsSameStore(shipments, idx)}
                    style={ShipmentsUtils.shipmentStylePadding(shipments, idx)}
                    details={
                        `${translations[this.props.locale]['shipment.word']} ${cont + 1}`
                        + ` ${translations[this.props.locale]['of.word']} ${storeIdsCount[shipment.attributes.store_ids[0]]}`
                    }
                />
            );
        });

        return (
            <div className="confirmation-details-block">
                {this._panelHeaderMarkup()}
                <div>{shipmentsMarkup}</div>
            </div>
        );
    }
}

export default OrderPanelView;



/** WEBPACK FOOTER **
 ** ./src/components/order/panel-view.jsx
 **/